import { useQuery } from "@apollo/client";

import { LOAD_TERMS_QUERY } from "globals/graphql/term.graphql";
import { useOperator, useOperatorSlug, useSnackbar } from "globals/hooks";
import { SMS_TERMS } from "pages/terms-and-conditions/smsTerms";

type Term = {
  id: string;
  name: string;
  description: string;
}

type UseTermsAndConditionsProps = {
  withSmsTerms?: boolean;
};

function useTermsAndConditions(params?: UseTermsAndConditionsProps) {
  const { withSmsTerms } = params || {};

  // hooks
  const operatorSlug = useOperatorSlug();
  const snackbar = useSnackbar();
  const { operator } = useOperator();

  const { data: termsData, error } = useQuery(LOAD_TERMS_QUERY, {
    variables: {
      operatorSlug,
    },
  });

  if (error) {
    snackbar.error(error.message);
  }

  // Combine operator defined terms with mandatory SMS terms
  if (withSmsTerms) {
    const companyName = operator?.name;
    const smsTerms: Term[] = SMS_TERMS.map(term => ({
      ...term,
      description: term.description.replace(/\[Company\]/g, companyName)
    }));
    return [...(termsData?.terms || []), ...smsTerms];
  }

  return termsData?.terms;
}

export { useTermsAndConditions };
